import {
  AgxIconCircularGreenTick,
  AgxIconCircularWarning,
} from '@urbanx/agx-ui-components'
import { AgxColumn, AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2'
import { Pages } from 'constants/menu'
import { useCallback } from 'react'
import { Link, useParams } from 'react-router-dom'
import './LeftSubmenu.scss'

export type SubPageStatusIndicator = 'success' | 'error'

export interface SubPage {
  title: string
  link: Pages
  statusIndicator?: SubPageStatusIndicator
}

interface ContractSubPageProps {
  currentPage: Pages
  subPages: SubPage[]
}

function LeftSubmenu({ currentPage, subPages }: ContractSubPageProps) {
  const { agencyId, campaignId, contractId } = useParams()

  const generateLink = useCallback(
    (pageLink: string) => {
      if (pageLink === '') return '/'

      if (agencyId) {
        if (contractId) {
          return `/${Pages.AGENCIES}/${agencyId}/campaigns/${campaignId}/contracts/${contractId}/${pageLink}`
        } else if (campaignId) {
          return `/${Pages.AGENCIES}/${agencyId}/campaigns/${campaignId}/${pageLink}`
        }

        return `/${Pages.AGENCIES}/${agencyId}/${pageLink}`
      }
      return pageLink || '#'
    },
    [agencyId, campaignId, contractId]
  )

  const getStatusTestId = (link: Pages, status: SubPageStatusIndicator) => {
    const normalized = link.replace(/[^a-z0-9]+/gi, '-').replace(/^-+|-+$/g, '')
    return `subPageStatus-${normalized}-${status}`
  }

  return (
    <div className="leftMenuContainer">
      <AgxColumn gap="spacing-none" fill>
        {subPages.map((subPage) => {
          const isCurrent = currentPage === subPage.link

          return (
            <div key={subPage.link} className="leftMenu">
              <AgxSpacer
                direction="horizontal"
                contentAlignment="center"
                padding={{
                  left: 'spacing-xs',
                  right: 'spacing-xs',
                  top: 'spacing-md',
                  bottom: 'spacing-md',
                }}
              >
                {subPage.statusIndicator ? (
                  <div className="tickBox">
                    <span
                      className="leftMenuStatusIndicator"
                      data-testid={getStatusTestId(
                        subPage.link,
                        subPage.statusIndicator
                      )}
                    >
                      {subPage.statusIndicator === 'success' ? (
                        <AgxIconCircularGreenTick width={20} height={20} />
                      ) : (
                        <AgxIconCircularWarning width={20} height={20} />
                      )}
                    </span>
                  </div>
                ) : null}
                <Link
                  to={generateLink(subPage.link)}
                  className={`leftMenuLinkStyle ${isCurrent ? 'selected' : ''}`}
                >
                  <AgxTypography
                    id={`subPageTitle-${subPage.link.replace(/\s+/g, '-')}`}
                    size="small"
                    type={isCurrent ? 'body_ui_strong' : 'body_ui'}
                    color={
                      isCurrent ? 'var(--text-primary)' : 'var(--text-tertiary)'
                    }
                  >
                    {subPage.title}
                  </AgxTypography>
                </Link>
              </AgxSpacer>
            </div>
          )
        })}
      </AgxColumn>
    </div>
  )
}

export default LeftSubmenu
